export default __webpack_public_path__ + "proximanova-light-webfont.woff2";